export abstract class BlobPrinterService {
  abstract print({ blob, name }: { blob: Blob; name: string }): Promise<void>;
}
